import { styled } from '@mui/material/styles';
import { Box, Typography, Card, Button, IconButton } from '@mui/material';

export const PageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  minHeight: '100vh',
  backgroundColor: '#E7EFF5',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const MainContent = styled(Box)<{ sidebarOpen: boolean }>(({ theme, sidebarOpen }) => ({
  flexGrow: 1,
  maxWidth: '100%',
  width: '100%',
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: 0,
  ...(sidebarOpen && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  backgroundColor: '#E7EFF5',
  minHeight: '100%',
  padding: '24px',
  overflowX: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    padding: 16,
  },
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  marginBottom: 32,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 16,
  [theme.breakpoints.down('sm')]: {
    marginBottom: 16,
  },
}));

export const HeaderLeft = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
});

export const ToggleButton = styled(IconButton)({
  color: '#003140',
  backgroundColor: 'white',
  width: 40,
  height: 40,
  '&:hover': {
    backgroundColor: '#E7EFF5',
  },
});

export const WelcomeText = styled(Typography)(({ theme }) => ({
  color: '#003140',
  fontWeight: 500,
  fontSize: '2.25rem',
  [theme.breakpoints.down('md')]: {
    fontSize: '2rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
  },
}));

export const DateText = styled(Typography)({
  color: 'rgb(7, 49, 66)',
  fontSize: '1rem',
  textAlign: 'center',
});

export const DateDivider = styled(Box)(({ theme }) => ({
  width: '2px',
  height: '20px',
  backgroundColor: 'red',
  margin: '0 12px',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const DateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: 8,
  },
}));

export const BannerImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  marginBottom: 48,
  maxHeight: '250px',
  objectFit: 'contain',
  [theme.breakpoints.down('sm')]: {
    marginBottom: 24,
    maxHeight: '200px',
  },
}));

export const DashboardCard = styled(Card)({
  height: '100%',
  cursor: 'pointer',
});

export const IconContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 16,
});

export const RightNavigation = styled(Box)(({ theme }) => ({
  width: '300px',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: '0 16px 16px 0',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    padding: '0 16px 16px 16px',
    order: -1,
  },
}));

export const QuickLinksContainer = styled(Box)(({ theme }) => ({
  maxHeight: '270px',
  marginTop: '20px',
  width: '100%',
  backgroundColor: 'white',
  borderRadius: 4,
  overflow: 'hidden',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.down('md')]: {
    marginTop: '16px',
  },
}));

export const QuickLinksContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  padding: 16,
});

export const QuickLinkButton = styled(Button)({
  color: '#003140',
  justifyContent: 'flex-start',
  textTransform: 'none',
  padding: '8px 16px',
  borderRadius: 4,
  '&:hover': {
    backgroundColor: '#E7EFF5',
  },
  fontSize: '0.9rem',
  fontWeight: 500,
});

export const DoubleChevronContainer = styled(Box)({
  position: 'relative',
  width: 24,
  height: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledChevronIcon = styled(Box)({
  position: 'absolute',
 
}); 